


























import Vue from 'vue';
import { BRow, BCol, BFormInput } from 'bootstrap-vue';
import { get, includes } from 'lodash';

import { parseQuery } from '@/utils/query_parser';

export default Vue.extend({
  name: 'FilterInput',
  components: {
    BCol,
    BFormInput,
    BRow,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    queryValid(): boolean {
      const parsedQuery = this.parseQuery(this.value);
      const isValid = get(parsedQuery, 'expression.op.name');
      return isValid && !includes(['text_search', 'exclude_text_search'], isValid);
    },
  },
  methods: {
    parseQuery,
  },
});
